import { render, staticRenderFns } from "./time-period.vue?vue&type=template&id=c47a578a&scoped=true"
import script from "./time-period.vue?vue&type=script&lang=js"
export * from "./time-period.vue?vue&type=script&lang=js"
import style0 from "./time-period.vue?vue&type=style&index=0&id=c47a578a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47a578a",
  null
  
)

export default component.exports